var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"speaker"},[_c('video',{ref:"myvideo",attrs:{"src":"","loop":"","type":"video/mp4","preload":"metadata","muted":""},domProps:{"muted":true}}),_c('canvas',{ref:"canvas",attrs:{"willReadFrequently":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }